<template>
  <div class="form-grid">
      <div class="form-group col-16 text-center">
            Estrena un auto del año, llévatelo nuevecito de la agencia:
      </div>
      <div class="flex w-full justify-content-between px-1 step-1-form">
        <div class="form-fields">
          <div class="form-group w-full">
              <label class="form-label tx-gray-ad" for="brands_select">
              Estado*
              </label>
              <v-select   v-model="carInfo.state"
                          :reduce="states => states"
                          :options="getStates()"
                          placeholder="Selecciona un estado"
                          label="name"
                          class="form-input"
                          name="states"
                          :clearable=false
                          id="states_select"
                          @input="loadDealerships()"
                          style="min-width:200px;">
                <span slot="no-options">
                    {{
                        statesLoads && getStates().length == 0
                            ? "Sin resultados"
                            : "Cargando..."
                    }}
                </span>
              </v-select>
          </div>
          <div class="form-group w-full" style="padding-left: 0">
              <label class="form-label tx-gray-ad" for="brands_select">
              Agencia*
              </label>
              <v-select   v-model="carInfo.dealership"
                          :reduce="dealerships => dealerships"
                          :options="getDealerships()"
                          placeholder="Selecciona una agencia"
                          label="name"
                          class="form-input"
                          name="dealership"
                          :clearable=false
                          id="dealership_select"
                          @input="loadModels()"
                          style="min-width:200px;"
                          :disabled="carInfo.state == null">
              <span slot="no-options">
                  {{
                      dealershipsLoads && getStates().length == 0
                          ? "Sin resultados"
                          : "Seleccione un estado para continuar..."
                  }}
              </span>
              </v-select>
          </div>
          <div class="form-group w-full" style="padding-right: 0">
              <label class="form-label tx-gray-ad" for="models_select">
              Modelo*
              </label>
              <v-select
                    v-model="carInfo.model"
                    :reduce="brand_new_models => brand_new_models"
                    :options="getModels()"
                    placeholder="Seleccionar"
                    label="name"
                    class="form-input"
                    name="models"
                    :clearable=false
                    id="models_select"
                    style="min-width:200px;"
                    :disabled="carInfo.dealership == null"
                    >
                <span slot="no-options">{{
                        modelsLoads && getDealerships().length == 0
                            ? "Sin resultados"
                            : "Seleccione una agencia para continuar..."
                    }}
                </span>
              </v-select>
          </div>
        </div>
        <div class="car-preview flex align-items-center py-4 justify-content-center text-center">
          <div v-if="carInfo.model && carInfo.model.image" style="width: 350px;">
            <img :src="carInfo.model.image" alt="" style="width: 100%;">
            <small class="block text-left">*Imagen alusiva a modelo y año, el color puede variar de acuerdo a disponibilidad.</small>
          </div>
        </div>
      </div>
      <div class="w-full">
        <div class="form-group col col-sm-16 pl-0 pr-0" style="margin-bottom: 0px">
            <button @click="addCar" :disabled="isEmpty" :class="{'diabled-add': isEmpty}" class="btn btn--green-ad m-2" >
                <span class="block">Agregar</span>
            </button>
        </div>
        <div class="form-group w-full pl-0 pr-0">
          <small class="tx-lightgrey-1" style="font-size: calc(0.2vw + 0.60rem); padding-left: 5px;">
            Agrega hasta 3 marcas para realizar la búsqueda.
          </small>
        </div>
        <div class="col-16">
            <table class="border w-full mb-3">
                <thead>
                    <tr>
                        <th class="uppercase">Marca</th>
                        <th class="uppercase">Modelo</th>
                        <th class="uppercase">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr :key="index" v-for="(car, index) in filters.searched_car_options">
                        <td align="center">{{ car.brand}}</td>
                        <td align="center">{{ car.model}}</td>
                        <td align="center">
                            <a @click="removeItem(index)">
                                <i class="fas fa-trash"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>
  </div>
</template>
<script>
import {
  mapState
} from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate";
import es from 'vee-validate/dist/locale/es.json';

import * as rules from "vee-validate/dist/rules";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
Vue.component("v-select", vSelect);
localize('es', es);
const MAX_SEARCHED_CARS = 3;
export default {
    components:{
        ValidationObserver,
        ValidationProvider
    },
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      statesLoads: false,
      dealershipsLoads: false,
      modelsLoads: false,
      colorsLoads: false,
      allDealerships: false,
      emptyCarInfo: {
        state: null,
        brand: null,
        model: null,
        dealership: null,
      },
      carInfo: {
        state: null,
        brand: null,
        model: null,
        dealership: null,
      }
    }
  },
  computed: {
    isEmpty() {
        return (this.carInfo.state === null || this.carInfo.dealership === null || this.carInfo.model === null) ? true : false
    }
  },
  watch: {
    filters: {
      handler(newVal) {
        this.$emit("filters", newVal);
      },
      deep: true
    },
    data: {
      handler(value) {
        if (value) {
          this.filters = value;
        }
      },
      deep: true
    },
    allDealerships: {
      handler(val) {
        if(val)
          this.carInfo.dealerships = this.getDealerships()
      }
    },
    'carInfo.model': {
      handler(val){
        this.carInfo.dealerships = []
        this.allDealerships = false
      }
    },
    'carInfo.brand': {
      handler(val){
        this.carInfo.model = null
        this.carInfo.dealerships = []
        this.allDealerships = false
      }
    },
    'carInfo.state': {
      handler(val){
        this.carInfo.brand = null
        this.carInfo.model = null
        this.carInfo.dealerships = []
        this.allDealerships = false
      }
    }
  },
  mounted() {
    this.loadStates()
},
  methods: {
    loadStates() {
        this.$store.dispatch("centralApi/getStates")
    },
    loadDealerships() {
      this.carInfo.dealership = null
      this.$store.dispatch("centralApi/getDealerships", this.carInfo.state.value)
    },
    loadModels () {
      this.carInfo.model = null
      this.$store.dispatch('centralApi/getBrandNewModels', this.carInfo.dealership.value)
    },
    getStates() {
      return this.$store.state.centralApi.states;
    },
    getModels() {
      return this.$store.state.centralApi.brand_new_models;
    },
/*     getModels() {
      return _.map(this.$store.state.intelimotor.modelsNew, function (item, key) {
        return {
          name: item.Nombre,
          value: item.Clave
        };
      });
    }, */
    getDealerships() {
      return this.$store.state.centralApi.dealerships;
    },
    addCar () {
      
        if (this.filters.searched_car_options.length === MAX_SEARCHED_CARS) {
            this.filters.messageError = 'Solo puedes agregar 3 marcas.'
            this.clearCarInfo()
            return
        }
        
        this.filters.searched_car_options.push({
          brand: this.carInfo.dealership.selling_brand,
          model: this.carInfo.model.name,
          state_id: this.carInfo.state.value,
          mkt_brand_new_vehicle_id: this.carInfo.model.value
        })

        this.clearCarInfo()
        this.filters.messageError = ''
    },
    getCarDealerships() {
      let result = this.getDealerships()
      if(!this.allDealerships && this.carInfo.dealerships.length > 0) 
        result = this.carInfo.dealerships

      return result
    },
    removeItem (index) {
        this.filters.searched_car_options.splice(index, 1)
    },
    clearCarInfo() {
        Object.assign(this.carInfo, this.emptyCarInfo)
        this.allDealerships = false
    }
  }
}
</script>
<style>
.diabled-add {
opacity: 0.8;
pointer-events: none;
}

.vs__deselect {
align-items: center;
}

#dealerships_select {
border: 1px solid #e2e5ed;
box-shadow: inset 0 1px 2px 0 rgba(102,113,123,.21);
}
</style>

<style lang="scss" scoped>
  .step-1-form {
    flex-direction: column;
    @media screen and (min-width: 1024px) {
      flex-direction: row;
    }
    .form-fields {
      @media screen and (min-width: 1024px) {
        width: 40%;
      }
    }
    .car-preview {
      @media screen and (min-width: 1024px) {
        width: 60%;
      }
    }
  }
</style>